<ion-header class="n-fej">
  <div class="n-sav">
    <!-- Fókusz témában asztali nézetben nincs bal sáv (a profil-lenyíló adja a keret műveleteit),
         a hamburger csak mobilon; Klasszikusban a bal sáv látszik, a gomb magától elrejtőzik. -->
    <ion-menu-button class="n-hamb" [class.csak-mobil]="fokusz" title="Profil, intézmény- és modulváltás"></ion-menu-button>

    <button class="n-marka" type="button" (click)="fomenuOldal()" title="Főmenü">
      <img class="n-logo" [src]="modIkon" alt="">
      <span class="n-marka-szoveg">{{ alrendszerNev }}</span>
    </button>

    <!-- FŐMENÜ: csak kiválasztott ügyfél mellett (ügyfél nélkül semmi más nem jelenik meg). -->
    <nav class="n-fomenu" *ngIf="aktiv.ugyfelId">
      <button *ngFor="let x of menuk" type="button"
              [class.nyitva]="nyitottMenu === x.f.kulcs"
              [class.aktiv]="aktivFomenu === x.f.kulcs"
              (click)="menuValt(x.f.kulcs, $event)"
              [title]="x.f.cim + ' (' + modBill + x.f.cim[0] + ')'">
        <ion-icon [name]="x.f.ikon"></ion-icon>
        <span><u>{{ x.f.cim[0] }}</u>{{ x.f.cim.slice(1) }}</span>
        <ion-icon class="n-nyil" name="chevron-down"></ion-icon>
      </button>
    </nav>

    <div class="n-ter"></div>

    <!-- Háttérfeladat-jelző: tétlen ikon, munka közben kör alakú haladásjelző. -->
    <button class="feladat-jelzo" type="button" (click)="feladatReszletek($event)"
            [title]="jelzoCim()" [class.hibas]="jelzoAllapot() === 'hiba'" [class.kesz]="jelzoAllapot() === 'kesz'">
      <ng-container *ngIf="jelzoAllapot() === 'fut'; else nyugalom">
        <span class="kor" [class.hatarozatlan]="foFeladatSzazalek() === null">
          <svg viewBox="0 0 36 36">
            <circle class="palya" cx="18" cy="18" r="15.915"></circle>
            <circle class="ertek" cx="18" cy="18" r="15.915"
                    [attr.stroke-dasharray]="((foFeladatSzazalek() ?? 0.25) * 100) + ' 100'"></circle>
          </svg>
          <b *ngIf="foFeladatSzazalek() !== null">{{ (foFeladatSzazalek()! * 100) | number:'1.0-0' }}</b>
        </span>
        <span *ngIf="futoFeladatok.length > 1" class="db">{{ futoFeladatok.length }}</span>
      </ng-container>
      <ng-template #nyugalom><ion-icon [name]="jelzoIkon()"></ion-icon></ng-template>
    </button>

    <!-- Az aktív ügyfél, a könyvelési mód és az év. Kattintásra az ügyfélválasztó. -->
    <button class="n-ugyfel" type="button" (click)="ugyfelValaszto()" title="Ügyfél választása">
      <span *ngIf="aktiv.ugyfelId" class="n-mod" [class.kettos]="aktiv.konyveles_mod === 'kettos'">
        {{ aktiv.konyveles_mod === 'kettos' ? 'Kettős' : 'Egyszeres' }}
      </span>
      <span class="n-ugyfel-nev">{{ aktiv.ugyfelNev || 'Válassz ügyfelet' }}</span>
      <span class="n-ev">{{ aktiv.ev }}</span>
      <ion-icon name="swap-horizontal-outline"></ion-icon>
    </button>

    <app-profil-menu *ngIf="fokusz" class="csak-asztal"></app-profil-menu>
  </div>

  <!-- A megnyitott főmenü almenüi – csempék. -->
  <div class="n-lenyilo" *ngIf="nyitottMenu && lenyiloPontok.length" (click)="$event.stopPropagation()">
    <div class="n-lenyilo-belso">
      <button *ngFor="let p of lenyiloPontok" type="button" class="n-csempe"
              [class.aktiv]="aktivPont === p.kulcs" [class.tiltott]="tiltott(p)" [disabled]="tiltott(p)"
              [title]="tiltott(p) ? 'Előbb nyisd meg a(z) ' + aktiv.ev + '. évet (Nyitás / zárás).' : ''"
              (click)="pontNyit(p)">
        <span class="n-csempe-ikon"><ion-icon [name]="p.ikon"></ion-icon></span>
        <span class="n-csempe-cim">{{ p.cim }}</span>
        <span class="n-csempe-leiras">{{ p.leiras }}</span>
      </button>
    </div>
  </div>
</ion-header>

<!-- A lenyitott menü alatti terület kattintásra bezárja a menüt. -->
<div class="n-fatyol" *ngIf="nyitottMenu" (click)="nyitottMenu = null"></div>

<!-- Háttérfeladat-részletek. Saját sablon (nem ion-alert), mert az alert `message`-e sima szöveg:
     a HTML-t nyersen kiírná. Az adat így Angular-kötésen megy – idézőjel/< jel sem törheti el. -->
<ion-popover class="feladat-popover" [isOpen]="feladatPopover" [event]="feladatEsemeny"
             (didDismiss)="feladatPopover = false" [showBackdrop]="true">
  <ng-template>
    <div class="fp">
      <div class="fp-fej">Háttérfeladatok</div>

      <div class="fp-ures" *ngIf="!feladatok.length">
        <ion-icon name="checkmark-circle-outline"></ion-icon>
        Nincs futó vagy nemrég befejezett lekérés.
      </div>

      <div class="fp-sor" *ngFor="let f of feladatok"
           [class.fut]="f.allapot === 'fut'" [class.hibas]="f.allapot === 'hiba'" [class.megszakitva]="f.allapot === 'megszakitva'">
        <ion-spinner *ngIf="f.allapot === 'fut'" name="dots"></ion-spinner>
        <ion-icon *ngIf="f.allapot !== 'fut'" [name]="f.allapot === 'hiba' ? 'alert-circle' : (f.allapot === 'megszakitva' ? 'stop-circle' : 'checkmark-circle')"></ion-icon>
        <div class="fp-szoveg">
          <b>{{ f.cimke }}</b>
          <span>{{ feladatAllapotSzoveg(f) }}</span>
          <ion-progress-bar *ngIf="f.allapot === 'fut'"
                            [value]="szazalek(f) ?? 0"
                            [type]="szazalek(f) === null ? 'indeterminate' : 'determinate'"></ion-progress-bar>
        </div>
        <!--  Megszakítás: ha a NAV nem válaszol, a lekérés beragadhat, és amíg „fut", ugyanarra
              az ügyfélre nem indítható új. Innen leállítható, nem kell az elévülésre várni. -->
        <ion-button *ngIf="f.allapot === 'fut'" size="small" fill="clear" color="danger" class="fp-megszakit"
                    [disabled]="megszakitFut === f.id" title="A lekérés leállítása"
                    (click)="feladatMegszakit(f)">
          <ion-spinner *ngIf="megszakitFut === f.id" name="dots"></ion-spinner>
          <span *ngIf="megszakitFut !== f.id">Megszakítás</span>
        </ion-button>
      </div>

      <div class="fp-lab">
        <ion-button size="small" fill="clear" color="medium" *ngIf="keszFeladatok.length" (click)="keszTorles()">
          Befejezettek törlése
        </ion-button>
        <ion-button size="small" fill="clear" (click)="feladatPopover = false">Bezár</ion-button>
      </div>
    </div>
  </ng-template>
</ion-popover>

<ion-content class="n-tartalom">
  <!-- A saját címsor nélküli oldalaknak a burok írja ki a címet a főmenü-pontból. -->
  <div class="n-auto-cim" *ngIf="autoCim as c">
    <h2>{{ c.cim }}</h2>
    <span class="n-auto-hol">{{ c.fomenu }}</span>
    <span class="n-auto-leiras" *ngIf="c.leiras">· {{ c.leiras }}</span>
  </div>
  <router-outlet></router-outlet>
</ion-content>
